import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ClinicProvider from "./Provider/ClinicProvider/ClinicProvider";
import DoctorProvider from "./Provider/DoctorProvider/DoctorProvider";
import SearchProvider from "./Provider/SearchProvider/SearchProvider";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <SearchProvider>
      <DoctorProvider>
        <ClinicProvider>
          <App />
        </ClinicProvider>
      </DoctorProvider>
    </SearchProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
